// src/contexts/AuthContext.js
import React, { createContext, useState } from "react";
import { jwtDecode } from "jwt-decode";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // Initialize token from localStorage if present
  const initialToken = localStorage.getItem("token");
  const [token, setToken] = useState(initialToken);

  const [user, setUser] = useState(() => {
    if (initialToken) {
      try {
        const decoded = jwtDecode(initialToken);
        return { username: decoded.username, role: decoded.role, id: decoded.id };
      } catch (err) {
        console.error("Invalid stored token on init:", err);
        return null;
      }
    }
    return null;
  });

  const login = (jwt) => {
    localStorage.setItem("token", jwt);
    const decoded = jwtDecode(jwt);
    setUser({ username: decoded.username, role: decoded.role, id: decoded.id });
    setToken(jwt);
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(null);
    setToken(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};